import { SetOptional } from 'type-fest'

import { PractitionerPreviewContent } from '~/app/pages/shared/Practitioner/PractitionerPreview'
import { AstraHoverCard, AstraPractitionerChip } from '~/astra'
import { Practitioner, usePractitioner } from '~/storm'

import { PractitionerChipProps, PractitionerChipWithTooltip } from './PractitionerChip'

const BasePractitionerChipWithHover = ({ practitioner, ...props }: Partial<PractitionerChipProps> & { practitioner: Practitioner }) => (
    <AstraHoverCard hoverContent={<PractitionerPreviewContent practitioner={practitioner} />}>
        <span>
            <AstraPractitionerChip {...props} shortName={practitioner.short_name.toLocaleUpperCase()} title={null} variant="ghost" />
        </span>
    </AstraHoverCard>
)

const PractitionerChipWithHoverStore = (props: PractitionerChipProps) => {
    const practitioner = usePractitioner({ where: { short_name: props.shortName }, include: { dipsResource: true } })

    if (!practitioner) {
        return <PractitionerChipWithTooltip {...props} />
    }

    return <BasePractitionerChipWithHover {...props} practitioner={practitioner} />
}

type PractitionerChipWithHoverProps = PractitionerChipProps | (SetOptional<PractitionerChipProps, 'shortName'> & { practitioner: Practitioner })

export const PractitionerChipWithHover = ({ ...props }: PractitionerChipWithHoverProps) => {
    if ('practitioner' in props) {
        return <BasePractitionerChipWithHover {...props} practitioner={props.practitioner} />
    }

    return <PractitionerChipWithHoverStore {...props} />
}
